import React, { useRef, useEffect } from "react";

interface StaticWaveformProps {
  mockData: Float32Array;
  width?: number;
  height?: number;
  barWidth?: number;
  barGap?: number;
}

export const StaticWaveform: React.FC<StaticWaveformProps> = ({
  mockData,
  width = 600,
  height = 50,
  barWidth = 3,
  barGap = 3,
}) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = width;
    canvas.height = height;

    ctx.clearRect(0, 0, width, height);

    const grad = ctx.createLinearGradient(0, 0, width, 0);
    grad.addColorStop(0, "#06B6D4");
    grad.addColorStop(1, "#9578ED");

    ctx.strokeStyle = grad;
    ctx.lineWidth = barWidth;

    const totalBars = Math.floor(width / (barWidth + barGap));

    const step = mockData.length / totalBars;

    const centerY = height / 2;

    for (let i = 0; i < totalBars; i++) {
      const x = i * (barWidth + barGap) + barWidth / 2;

      const dataIndex = Math.floor(i * step);
      const value = mockData[dataIndex];

      const barHeight = Math.abs(value) * (height / 2);

      ctx.beginPath();
      const top = centerY - barHeight;
      const bottom = centerY + barHeight;
      ctx.moveTo(x, top);
      ctx.lineTo(x, bottom);
      ctx.stroke();
    }
  }, [mockData, width, height, barWidth, barGap]);

  return <canvas ref={canvasRef} style={{ width: "100%", display: "block" }} />;
};
